import styled from "styled-components";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { BodyDiv } from "../../../../components/components-style";
import { CaptionText, LabelText, LittleSubHeadline, NotificationText } from "../../../../components/typography";
import SendInviteBlock from "../../../../components/ui/send-invite-block";
import { Block } from "../../main";
import { COLORS } from "../../../../assets/utils/enums/colors";
import Input, { InputStyle } from "../../../../components/ui/inputs";
import { useState } from "react";
import { Button } from "../../../../components/ui/button";

export default function SendInviteTeam() {
    const [emailInvite, setEmailInvite] = useState<string>("Example@gmail.com");
    return (
        <BodyDiv
            className={`${SETTINGS_BODY_DIV} justify-content-between`}
            $isPadding={true}
        >
            <Block
                className={`w-100 d-flex flex-column align-items-center gap-2`}
            >
                <CaptionText>Запросити за посиланням</CaptionText>
                <SendInviteBlock link={"https://www.linkedin.com/company/lemonade-stand-marketing"} />
                <LineString>
                    <NotificationText>або</NotificationText>
                </LineString>
                <SendPostInviteBlock>
                    <CaptionText>Відправити запрошення на пошту</CaptionText>
                    <span className="w-100 d-flex gap-1 justify-content-between align-items-center">
                        <Input attribute={"send-email-invite"} label={""} errorText={""} placeholder={""} value={emailInvite} setValue={setEmailInvite} />
                        <Button bgcolor={COLORS.secondary1}
                            txtcolor={COLORS.white}
                            brcolor={COLORS.secondary1}
                            width="auto"
                            brradius="24px"
                            type="large" onClick={() => { }}>
                            <LittleSubHeadline>Надіслати</LittleSubHeadline>
                        </Button>
                    </span>
                </SendPostInviteBlock>
            </Block>
        </BodyDiv>
    )
}

const SendPostInviteBlock = styled.div`
width: 100%;
${InputStyle} {
    padding: 8px 0;
    ${LabelText} {
        display: none;
    }
}

${CaptionText} {
    padding-left: 20px;
}
        img {
            width: 24px !important;
            height: 24px !important;
            margin-right: 6px;
        }
`

const LineString = styled.div`
    height: 1px;
    width: 100%;
    background-color: ${COLORS["light-bg-color"]};
    border-radius: 5px;
    margin: 16px 0;
    

    ${NotificationText} {
        background-color: ${COLORS.white};
        color: ${COLORS["bg-text-color"]};
        width: min-content;
        padding: 5px 10px;
        position: relative;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`